import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefGetHashQuery, KsefGetHashQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefGetHashQuery)
@Wrapper(KsefGetHashQueryHandlerBase)
export class KsefGetHashQueryHandler {
    public constructor(
        http: Http
    ) { }
}
